import { FlexSmartShareQuery, FlexSmartShareArgs, FlexSmartShareResponse } from '../../autogenerated/ZoomBridge';

export default class FlexSmartLinkExecutor {
  constructor(fuids, name, destDir, isWritable, isSuffix,comment) {
    this.fuids = fuids;
    this.name = name;
    this.destDir = destDir;
    this.isWritable = isWritable;
    this.isSuffix = isSuffix;
    this.comment = comment;
  }

  run(): Promise<FlexSmartShareResponse> {
    const query = new FlexSmartShareQuery();
    const msg = new FlexSmartShareArgs();
    msg.setSrcFuids(this.fuids);
    msg.setName(this.name);
    msg.setDestDir(this.destDir);
    msg.setIsWritable(this.isWritable);
    msg.setIsSuffix(this.isSuffix);
    msg.setLogMsg(this.comment);
    query.message = msg;
    return query.run();
  }
}
